import { render, staticRenderFns } from "./zhuanti-xiangcunzhenxing.vue?vue&type=template&id=0475ec72&"
import script from "./zhuanti-xiangcunzhenxing.vue?vue&type=script&lang=js&"
export * from "./zhuanti-xiangcunzhenxing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports